<h2 mat-dialog-title>{{ 'riskIndicators.showRawJson' | translate }}</h2>
<mat-dialog-content class="pep-raw-json-dialog-content">
  @if (shouldShowNoRecords) {
    <p class="no-records">{{ noRecordsText }}</p>
  } @else {
    <pre>{{ jsonString }}</pre>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button
          type="button"
          (click)="copyJson()">
    {{ 'riskIndicators.copyJson' | translate }}
  </button>
  <button mat-button
          mat-dialog-close>
    {{ 'global.close' | translate }}
  </button>
</mat-dialog-actions>
